// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Launch button */
.profile-contacts-button__section {
  width: 100%;
  min-width: 0;
  display: grid;
}

#add-to-contacts-button-container {
  position: relative;
  overflow: visible;
}

#add-to-contacts-button-container solid-ui-button.profile__btn-contacts {
  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));
  --profile-contacts-button-background-default: transparent;
  --profile-contacts-button-text-default: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));
  --profile-contacts-button-border-hover: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  --profile-contacts-button-background-hover: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));
  --profile-contacts-button-text-hover: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
  --button-padding-sm: var(--spacing-sm, 0.9375rem) var(--spacing-md, 1.25rem);
  --button-font-size-sm: var(--font-size-md, 1rem);
  --button-font-weight: var(--font-weight-normal, normal);
  --button-border-radius: var(--border-radius-base);
  --button-transition: all 0.3s ease-in-out;
  --button-focus-outline: var(--focus-indicator-width) solid var(--color-primary);
  --button-focus-outline-offset: var(--outline-offset-sm);
  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-focus-gap, var(--white, #FFF)), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha, rgba(124, 77, 255, 0.2)));
  --button-border: var(--profile-contacts-button-border-default);
  --button-background: var(--profile-contacts-button-background-default);
  --button-text: var(--profile-contacts-button-text-default);
  --button-hover-border: var(--profile-contacts-button-border-hover);
  --button-hover-background: var(--profile-contacts-button-background-hover);
  --button-hover-text: var(--profile-contacts-button-text-hover);
  color: var(--button-text);
}

html[data-theme="dark"] #add-to-contacts-button-container solid-ui-button.profile__btn-contacts {
  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));
}

#add-to-contacts-button-container .profile__btn-contacts-label {
  color: currentColor;
  font-size: inherit;
  font-weight: inherit;
  line-height: 1;
}

#add-to-contacts-button-container .profile__btn-contacts-icon {
  width: var(--icon-xxxs, 0.75rem);
  height: var(--icon-xxxs, 0.75rem);
  margin-right: var(--spacing-xxs, 0.3125rem);
  flex-shrink: 0;
}

#add-to-contacts-button-container .profile__btn-contacts-icon svg {
  width: var(--icon-xxxs, 0.75rem);
  height: var(--icon-xxxs, 0.75rem);
  display: block;
}

#add-to-contacts-button-container .profile__btn-contacts-icon path {
  fill: currentColor;
}

#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:hover .profile__btn-contacts-label,
#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:focus-visible .profile__btn-contacts-label {
  color: currentColor;
}

#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:hover .profile__btn-contacts-icon path,
#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:focus-visible .profile__btn-contacts-icon path {
  fill: currentColor;
}

#add-to-contacts-button-container solid-ui-button.profile__btn-contacts[disabled],
#add-to-contacts-button-container solid-ui-button.profile__btn-contacts[aria-disabled="true"] {
  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));
  --profile-contacts-button-background-default: transparent;
  --profile-contacts-button-text-default: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));
  --profile-contacts-button-border-hover: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  --profile-contacts-button-background-hover: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));
  --profile-contacts-button-text-hover: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
  opacity: 1;
}

/* Main dialog shell */
.contacts-dialog__content {
  --contacts-dialog-action-width: 10.8rem;
  --contacts-dialog-list-width: 20rem;
  --contacts-dialog-panel-width: 20.75rem;
  --contacts-dialog-mobile-popup-max-width: calc(92vw - 5px);
  --contacts-dialog-panel-border: var(--color-border-lighter, var(--slate-200, #E2E8F0));
  --contacts-dialog-panel-background: var(--color-background, #F8F9FB);
  --contacts-dialog-panel-header-background: var(--color-surface-overlay-header, var(--slate-50, #F8FAFC));
  --contacts-dialog-panel-body-background: var(--color-card-bg, #FFF);
  --contacts-dialog-panel-padding-inline: calc(var(--spacing-lg, 1.5625rem) + var(--spacing-xxs, 0.3125rem));
  --contacts-dialog-inner-footer-padding: var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem);
  --contacts-dialog-inner-footer-padding-mobile: var(--spacing-xs, 0.75rem) var(--spacing-sm, 0.9375rem);
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  max-height: none;
  min-width: 0;
}

.contacts-dialog__frame {
  min-width: 0;
  background: transparent;
  border-radius: 0;
  max-height: none;
  overflow: visible;
}

.contacts-dialog__main {
  width: 100%;
  min-width: 0;
  padding: var(--spacing-sm, 0.938rem);
  box-sizing: border-box;
}

.contacts-dialog__creation {
  width: 100%;
  min-width: 0;
  border-radius: 0;
  background: transparent;
  box-sizing: border-box;
  padding: 0;
  gap: 0;
}

.contacts-dialog__description {
  padding: var(--spacing-xs, 0.75rem);
  background: transparent;
  color: var(--color-text-secondary, var(--gray-600, #4A5565));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-regular, 400);
}

.contacts-dialog__body {
  min-width: 0;
  margin-top: var(--spacing-lg, 1.5625rem);
  overflow: auto;
}

.contacts-dialog__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-sm, 0.938rem);
  width: auto;
  min-width: 0;
  padding: var(--spacing-md, 1.25rem) var(--contacts-dialog-panel-padding-inline);
  border-top: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);
  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));
  box-sizing: border-box;
}

.contacts-dialog__footer > solid-ui-button {
  width: var(--contacts-dialog-action-width);
}

/* Shared button tokens */
solid-ui-button.contacts-dialog__action-button {
  --button-font-size-md: var(--font-size-sm, 0.875rem);
  --button-font-weight: var(--font-weight-md, 500);
  --button-background: var(--color-card-bg, var(--white, #FFF));
  --button-text: var(--color-text-control, var(--slate-700, #314158));
  --button-border: transparent;
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-base);
  --button-transition: all 0.3s ease-in-out;
  --button-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));
  --button-hover-border: transparent;
  --button-hover-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));
  --button-hover-box-shadow: none;
  --button-active-transform: none;
  --button-active-box-shadow: none;
  --button-focus-outline: 3px solid var(--color-primary);
  --button-focus-outline-offset: 2px;
  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));
}

solid-ui-button.contacts-dialog__action-button--primary {
  --button-height-md: 0;
  --button-background: var(--color-primary, #7C4DFF) !important;
  --button-text: var(--color-text-on-action, var(--white, #FFF)) !important;
  --button-border-width: 0.8px;
  --button-border: var(--color-primary, #7C4DFF) !important;
  --button-font-size-md: var(--font-size-md, 1rem);
  --button-font-weight: var(--font-weight-bold, 600);
  --button-line-height: 1;
  --button-padding-md: 0.85rem 1rem;
  --button-hover-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 85%, var(--black, #000)) !important;
  --button-hover-text: var(--color-text-on-action, var(--white, #FFF)) !important;
  --button-hover-border: var(--color-primary, #7C4DFF) !important;
  --button-hover-box-shadow: var(--box-shadow-hover, 0 2px 4px rgba(124, 77, 255, 0.2));
  --button-active-box-shadow: var(--box-shadow-active, 0 1px 2px rgba(124, 77, 255, 0.2));
}

solid-ui-button.contacts-dialog__action-button[disabled],
solid-ui-button.contacts-dialog__action-button[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.55;
  --button-box-shadow: none !important;
  --button-hover-box-shadow: none !important;
  --button-active-box-shadow: none !important;
  --button-active-transform: none;
}

solid-ui-button.contacts-dialog__action-button--primary[disabled],
solid-ui-button.contacts-dialog__action-button--primary[aria-disabled="true"] {
  --button-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 60%, var(--color-card-bg, var(--white, #FFF))) !important;
  --button-border-width: 0.8px;
  --button-border: color-mix(in srgb, var(--color-primary, #7C4DFF) 60%, var(--color-card-bg, var(--white, #FFF))) !important;
  --button-text: var(--color-text-on-action, var(--white, #FFF)) !important;
}

solid-ui-button.contacts-dialog__confirm {
  --button-padding-md: var(--spacing-sm) var(--spacing-md);
  --button-font-size-md: var(--font-size-md, 1rem);
  --button-font-weight: var(--font-weight-md, 500);
  --button-line-height: 1;
  --button-active-box-shadow: none;
}

solid-ui-button.contacts-dialog__cancel {
  --button-padding-md: var(--spacing-sm) var(--spacing-md);
  --button-font-size-md: var(--font-size-md, 1rem);
  --button-font-weight: var(--font-weight-normal, normal);
  --button-background: var(--dialog-cancel-button-background, transparent);
  --button-text: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));
  --button-border: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));
  --button-border-radius: var(--border-radius-base);
  --button-transition: all 0.3s ease-in-out;
  --button-hover-background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575)) !important;
  --button-hover-text: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
  --button-hover-border: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  --button-hover-box-shadow: none;
  --button-active-transform: none;
  --button-active-box-shadow: none;
  --button-focus-outline: var(--focus-indicator-width) solid var(--color-primary);
  --button-focus-outline-offset: var(--outline-offset-sm);
  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-focus-gap, var(--white, #FFF)), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha, rgba(124, 77, 255, 0.2)));
}

solid-ui-button.contacts-dialog__cancel:hover::part(button),
solid-ui-button.contacts-dialog__cancel:focus-visible::part(button),
solid-ui-button.contacts-dialog__cancel:focus-within::part(button) {
  background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));
  border-color: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));
  color: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));
}

solid-ui-button.contacts-dialog__cancel--footer {
  width: var(--contacts-dialog-action-width);
  min-width: var(--contacts-dialog-action-width);
  max-width: var(--contacts-dialog-action-width);
  inline-size: var(--contacts-dialog-action-width);
  align-self: auto;
}

.contacts-dialog__submit-contact {
  width: var(--contacts-dialog-action-width) !important;
  min-width: var(--contacts-dialog-action-width);
  max-width: var(--contacts-dialog-action-width);
  inline-size: var(--contacts-dialog-action-width);
  flex: 0 0 var(--contacts-dialog-action-width);
  align-self: flex-end;
  line-height: 1;
}

.contacts-dialog__address-submit {
  width: fit-content;
  min-width: fit-content;
  max-width: fit-content;
  inline-size: fit-content;
  flex: 0 0 auto;
  align-self: auto;
  margin: 0 0 0 auto;
  white-space: nowrap;
}

.contacts-dialog__group-submit {
  width: fit-content;
  min-width: fit-content;
  max-width: fit-content;
  inline-size: fit-content;
  flex: 0 0 auto;
  align-self: auto;
  margin: 0 0 0 auto;
  white-space: nowrap;
}

.contacts-dialog__uri-submit {
  width: fit-content;
  min-width: fit-content;
  max-width: fit-content;
  inline-size: fit-content;
  flex: 0 0 auto;
  align-self: auto;
  margin: 0 0 0 auto;
  line-height: 1;
  white-space: nowrap;
}

.contacts-dialog__uri-submit::part(button),
.contacts-dialog__address-submit::part(button) {
  width: auto;
  min-width: 0;
}

/* Selection layout */
.contacts-dialog__details {
  width: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: 0;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  gap: var(--spacing-sm, 0.938rem);
  padding: 0;
  overflow-x: auto;
  overflow-y: auto;
  background: transparent;
}

.contacts-dialog__address-book-list {
  flex: 0 0 15rem;
  width: 100%;
  max-width: 16rem;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  box-sizing: border-box;
}

.contacts-dialog__group-list {
  width: auto;
  max-width: 14rem;
  min-width: 12.5rem;
  box-sizing: border-box;
  gap: 1px;
}

.contacts-dialog__column-title {
  margin: 0 0 0.35rem;
  padding-bottom: 0.35rem;
  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-lg, 1.125rem);
}

#addressbook-list > solid-ui-button#contacts-create-addressbook-button,
#addressbook-list > solid-ui-button#contacts-addressbook-uri-entry-button,
#group-list > solid-ui-button#contacts-create-group-button {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  inline-size: 100% !important;
}

solid-ui-button.contacts-dialog__list-button {
  flex-shrink: 0;
  width: 100%;
  -webkit-tap-highlight-color: transparent;
  --button-height-sm: 0;
  --button-padding-sm: 0.85rem 1rem;
  --button-font-size-sm: var(--font-size-sm, 0.875rem);
  --button-font-weight: var(--font-weight-md, 500);
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-md, 0.5rem);
  --button-selected-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff)) !important;
  --button-selected-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));
  --button-selected-border: transparent;
  --button-box-shadow: none !important;
  --button-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff)) !important;
  --button-hover-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));
  --button-hover-border: transparent;
  --button-hover-box-shadow: none !important;
  --button-active-transform: none;
  --button-active-box-shadow: none !important;
  --button-focus-outline: none;
  --button-focus-box-shadow: none !important;
}

/* Inline panel shells */
.contacts-dialog__inline-panel-region {
  display: none;
  min-width: 0;
  order: 3;
}

.contacts-dialog__inline-panel-region--active {
  display: block;
  min-width: 0;
  width: min(100%, var(--contacts-dialog-panel-width)) !important;
  max-width: var(--contacts-dialog-panel-width) !important;
  align-self: flex-start;
  order: 3;
}

.contacts-dialog__inline-panel.contacts-dialog__popup {
  position: static;
  inset: auto;
  transform: none;
  min-width: 0;
  width: 100% !important;
  max-width: 100% !important;
  max-height: none;
  margin: 0;
  margin-right: 0;
  overflow: visible;
  box-shadow: none;
  border-left: 1px solid var(--contacts-dialog-panel-border);
}

.contacts-dialog__address-form,
.contacts-dialog__group-form,
.contacts-dialog__uri-entry {
  padding: 0 !important;
  gap: 0;
  box-sizing: border-box;
  border-radius: var(--border-radius-base);
}

.contacts-dialog__address-form {
  width: 100% !important;
  max-width: 100% !important;
  align-items: stretch;
  border: 1px solid var(--contacts-dialog-panel-border);
  background: var(--contacts-dialog-panel-background);
}

.contacts-dialog__group-form {
  border: none;
  border-left: 1px solid var(--contacts-dialog-panel-border);
  border-radius: 0;
  background: var(--contacts-dialog-panel-background);
}

.contacts-dialog__uri-entry {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  align-self: flex-start;
  border: 1px solid var(--contacts-dialog-panel-border);
  background: var(--contacts-dialog-panel-background);
}

.contacts-dialog__uri-entry-form {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: stretch;
  box-sizing: border-box;
  gap: 0;
  background: var(--color-card-bg, #FFF);
}

/* Popup chrome */
.contacts-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm, 0.938rem);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.contacts-dialog__title {
  margin: 0;
  min-width: 0;
  flex: 1 1 auto;
  line-height: 1.3;
  font-size: var(--font-size-md);
  color: var(--color-text-subheading, var(--gray-900, #101828));
}

.contacts-dialog__popup .contacts-dialog__header {
  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
}

.contacts-dialog__address-form .contacts-dialog__header,
.contacts-dialog__group-form .contacts-dialog__header,
.contacts-dialog__uri-entry .contacts-dialog__header {
  margin-bottom: 0;
  padding: var(--spacing-md, 1.25rem) var(--spacing-lg, 1.5625rem);
  border-bottom: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);
  background: var(--contacts-dialog-panel-header-background);
}

solid-ui-button.contacts-dialog__close {
  flex: 0 0 auto;
  align-self: flex-start;
  min-inline-size: var(--icon-base, 2rem);
  --button-height-sm: var(--icon-base, 2rem);
  --button-width-sm: var(--icon-base, 2rem);
  --button-padding-sm: 0;
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-border-radius: 999px;
  --button-text: var(--color-text);
  --button-box-shadow: none;
  --button-hover-background: rgba(0, 0, 0, 0.04);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary);
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  --button-icon-size-sm: var(--icon-xxs, 1rem);
}

solid-ui-button.contacts-dialog__close:focus-visible::part(button) {
  outline: var(--focus-indicator-width) solid var(--color-primary);
  outline-offset: var(--outline-offset-sm);
  box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));
}

.contacts-dialog__popup-body {
  min-width: 0;
  gap: var(--spacing-base, 0.5rem);
}

.contacts-dialog__address-form .contacts-dialog__popup-body,
.contacts-dialog__group-form .contacts-dialog__popup-body,
.contacts-dialog__uri-entry .contacts-dialog__popup-body {
  padding: var(--spacing-lg, 1.5625rem);
  box-sizing: border-box;
  background: var(--contacts-dialog-panel-body-background);
}

.contacts-dialog__popup .input {
  width: 100%;
  max-width: 100%;
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));
  background: var(--color-card-bg, var(--white, #FFF));
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  padding: var(--spacing-2xs, 0.625rem);
  box-sizing: border-box;
  margin-bottom: var(--spacing-base, 0.5rem);
}

.contacts-dialog__address-form .input,
.contacts-dialog__group-form .input,
.contacts-dialog__uri-entry .input {
  margin-bottom: 0;
}

.contacts-dialog__uri-input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: block;
  flex: 1 1 auto;
  align-self: stretch;
  box-sizing: border-box;
}

.contacts-dialog__popup-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  min-width: 0;
  align-self: stretch;
  box-sizing: border-box;
  gap: var(--spacing-md);
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);
  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));
}

.contacts-dialog__address-form .contacts-dialog__popup-footer,
.contacts-dialog__group-form .contacts-dialog__popup-footer,
.contacts-dialog__uri-entry .contacts-dialog__popup-footer {
  margin-top: 0;
  gap: var(--spacing-sm, 0.9375rem);
  padding: var(--contacts-dialog-inner-footer-padding);
}

.contacts-dialog__address-form .contacts-dialog__popup-footer,
.contacts-dialog__uri-entry-form .contacts-dialog__popup-footer {
  justify-content: flex-end;
}

.contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__confirm,
.contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__cancel {
  width: var(--contacts-dialog-action-width);
  min-width: var(--contacts-dialog-action-width);
  max-width: var(--contacts-dialog-action-width);
  inline-size: var(--contacts-dialog-action-width);
}

/* Validation and feedback */
.contacts-dialog__validation {
  display: none;
  width: calc(100% - 0.5rem);
  max-width: calc(100% - 0.5rem);
  margin: 0 auto;
  padding-right: 0.25rem;
  padding-left: 0.25rem;
  align-self: stretch;
  box-sizing: border-box;
  color: var(--red-600, #B00020);
  font-size: var(--font-size-sm, 0.875rem);
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: left;
}

.contacts-dialog__validation--visible {
  display: block;
}

.contacts-dialog__error,
.contacts-dialog__error[role='alert'] {
  position: relative;
  z-index: 3;
  display: none;
  width: 100%;
  align-self: stretch;
  margin: 0;
  padding: 0;
  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));
  border-radius: var(--border-radius-base);
  background: var(--dialog-error-background, var(--pink-500, #ffdde6));
  background-color: var(--dialog-error-background, var(--pink-500, #ffdde6));
  color: var(--dialog-error-text, var(--red-600, #B00020));
  text-align: center;
}

.contacts-dialog__error--visible {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
}

solid-ui-button.contacts-dialog__error-close {
  position: absolute;
  top: var(--spacing-xxxs, 0.2rem);
  right: var(--spacing-xxxs, 0.2rem);
  z-index: 4;
  --button-height-sm: 0;
  --button-padding-sm: 0;
  --button-font-size-sm: var(--font-size-sm);
  --button-background: transparent;
  --button-border: transparent;
  --button-border-width: 0;
  --button-border-radius: 0;
  --button-text: var(--dialog-error-text, var(--red-600, #B00020));
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: var(--dialog-error-text, var(--red-600, #B00020));
  --button-line-height: 1;
  --button-active-transform: none;
  --button-box-shadow: none;
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
}

/* Overlays and confirmation popups */
.contacts-dialog__popup-overlay {
  position: absolute;
  inset: 0;
  z-index: 8;
  background: color-mix(in srgb, var(--black, #000) 50%, transparent);
}

.contacts-dialog__popup {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  width: min(calc(24rem - 5px), calc(100% - 1rem - 5px));
  max-width: calc(100% - 1rem - 5px);
  max-height: min(calc(100% - 1rem - 5px), calc(100vh - 6rem - 5px));
  padding: 1rem;
  box-sizing: border-box;
  overflow: auto;
  overflow-x: hidden;
  transform: translate(-50%, -50%);
  border-radius: var(--border-radius-base);
  background: var(--color-surface-overlay, var(--white, #FFF)) !important;
  color: var(--color-text-overlay, var(--gray-800, #1E2939));
  box-shadow: var(--box-shadow-overlay, 0 4px 24px rgba(0, 0, 0, 0.2));
}

.contacts-dialog__shared-confirm-form {
  display: flex;
  flex-direction: column;
}

.contacts-dialog__shared-confirm-message {
  margin: 0;
  color: var(--color-text-overlay, var(--gray-800, #1E2939));
}

.contacts-dialog__shared-confirm-name {
  font-weight: var(--font-weight-bold, 600);
}

.contacts-dialog__contact-exists {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  width: min(90vw, 20rem);
  padding: 1rem;
  transform: translate(-50%, -50%);
  border-radius: var(--border-radius-base);
  background: var(--color-surface-overlay, var(--white, #FFF));
  color: var(--color-text-overlay, var(--gray-800, #1E2939));
  box-shadow: var(--box-shadow-modal, 0 2px 10px rgba(0, 0, 0, 0.3));
  align-items: center;
  gap: var(--spacing-md, 1rem);
  text-wrap: pretty;
}

.contacts-dialog__contact-exists .contacts-dialog__popup-footer {
  width: 100%;
  justify-content: center;
  gap: var(--spacing-2xs, 0.625rem);
  margin-top: var(--spacing-base, 0.5rem);
  padding-top: 0;
  border-top: none;
  background: transparent;
}

.contacts-dialog__contact-exists .contacts-dialog__confirm,
.contacts-dialog__contact-exists .contacts-dialog__cancel {
  width: auto;
  min-width: 6rem;
  flex: 0 0 auto;
  margin: 0;
  white-space: nowrap;
}

/* Responsive overrides */

/* Explicit mobile layout mode uses the same values as the small-screen rules,
   but plain CSS still needs a separate block because \`data-layout\` is not a media query. */
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__frame {
  max-height: none;
  overflow: visible;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__body {
  padding-bottom: 0;
  overflow: visible;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__footer {
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-sm, 0.9375rem);
  width: 100%;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__footer > solid-ui-button {
  flex: 1 0 0;
  width: auto;
  min-width: 0;
  max-width: none;
  inline-size: auto;
  --button-font-size-md: var(--font-size-md, 1rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__popup {
  max-width: var(--contacts-dialog-mobile-popup-max-width);
  max-height: 78vh;
  padding: 0.85rem;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form {
  width: min(100%, var(--contacts-dialog-panel-width)) !important;
  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
  margin-inline: auto;
  padding: 0 !important;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel-region {
  min-width: 0;
  width: min(100%, var(--contacts-dialog-list-width)) !important;
  max-width: min(100%, var(--contacts-dialog-list-width)) !important;
  margin-inline: auto;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel-region--active {
  width: min(100%, var(--contacts-dialog-panel-width)) !important;
  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__header,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__header,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__header {
  padding: var(--spacing-sm, 0.9375rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-body,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-body,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-body {
  gap: var(--spacing-base, 0.5rem);
  padding: var(--spacing-sm, 0.9375rem) var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem) var(--spacing-sm, 0.9375rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .input {
  min-height: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.375rem;
  padding: var(--spacing-base, 0.5rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-footer,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-footer {
  justify-content: flex-end;
  gap: var(--spacing-sm, 0.9375rem);
  padding: var(--contacts-dialog-inner-footer-padding-mobile);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-footer {
  justify-content: center;
  gap: var(--spacing-sm, 0.9375rem);
  padding: var(--contacts-dialog-inner-footer-padding-mobile);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-footer > solid-ui-button,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-footer > solid-ui-button {
  flex: 1 0 0;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  inline-size: auto !important;
  --button-font-size-md: var(--font-size-md, 1rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-submit,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-submit,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__submit-contact,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__cancel--footer {
  flex: 1 0 0 !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  inline-size: auto !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  align-self: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__group-submit {
  flex: 0 0 auto;
  width: fit-content;
  min-width: fit-content;
  max-width: fit-content;
  inline-size: fit-content;
  margin: 0 auto;
  align-self: auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__details {
  width: 100% !important;
  min-width: 0;
  max-height: none;
  padding: var(--spacing-base, 0.5rem) var(--spacing-base, 0.5rem) 0;
  overflow-y: visible;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-book-list,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-list {
  min-width: 0;
  width: min(100%, var(--contacts-dialog-list-width)) !important;
  max-width: min(100%, var(--contacts-dialog-list-width)) !important;
  margin-inline: auto;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel.contacts-dialog__popup,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form,
:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry {
  width: min(100%, var(--contacts-dialog-panel-width)) !important;
  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
  margin-inline: auto !important;
  align-self: center;
}

@media (max-width: 576px) {
  .contacts-dialog__frame {
    max-height: none;
    overflow: visible;
  }

  .contacts-dialog__body {
    padding-bottom: 0;
    overflow: visible;
  }

  .contacts-dialog__footer {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: var(--spacing-sm, 0.9375rem);
    width: 100%;
  }

  .contacts-dialog__footer > solid-ui-button {
    flex: 1 0 0;
    width: auto;
    min-width: 0;
    max-width: none;
    inline-size: auto;
    --button-font-size-md: var(--font-size-md, 1rem);
  }

  .contacts-dialog__popup {
    max-width: var(--contacts-dialog-mobile-popup-max-width);
    max-height: 78vh;
    padding: 0.85rem;
  }

  .contacts-dialog__address-form {
    width: min(100%, var(--contacts-dialog-panel-width)) !important;
    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
    margin-inline: auto;
    padding: 0 !important;
  }

  .contacts-dialog__inline-panel-region {
    min-width: 0;
    width: min(100%, var(--contacts-dialog-list-width)) !important;
    max-width: min(100%, var(--contacts-dialog-list-width)) !important;
    margin-inline: auto;
  }

  .contacts-dialog__inline-panel-region--active {
    width: min(100%, var(--contacts-dialog-panel-width)) !important;
    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
  }

  .contacts-dialog__address-form .contacts-dialog__header,
  .contacts-dialog__group-form .contacts-dialog__header,
  .contacts-dialog__uri-entry .contacts-dialog__header {
    padding: var(--spacing-sm, 0.9375rem);
  }

  .contacts-dialog__address-form .contacts-dialog__popup-body,
  .contacts-dialog__group-form .contacts-dialog__popup-body,
  .contacts-dialog__uri-entry .contacts-dialog__popup-body {
    gap: var(--spacing-base, 0.5rem);
    padding: var(--spacing-sm, 0.9375rem) var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem) var(--spacing-sm, 0.9375rem);
  }

  .contacts-dialog__address-form .input {
    min-height: 2.5rem;
    height: 2.5rem;
    margin-bottom: 0.375rem;
    padding: var(--spacing-base, 0.5rem);
  }

  .contacts-dialog__uri-entry .contacts-dialog__popup-footer,
  .contacts-dialog__address-form .contacts-dialog__popup-footer {
    justify-content: flex-end;
    gap: var(--spacing-sm, 0.9375rem);
    padding: var(--contacts-dialog-inner-footer-padding-mobile);
  }

  .contacts-dialog__group-form .contacts-dialog__popup-footer {
    justify-content: center;
    gap: var(--spacing-sm, 0.9375rem);
    padding: var(--contacts-dialog-inner-footer-padding-mobile);
  }

  .contacts-dialog__uri-entry .contacts-dialog__popup-footer > solid-ui-button,
  .contacts-dialog__address-form .contacts-dialog__popup-footer > solid-ui-button {
    flex: 1 0 0;
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    inline-size: auto !important;
    --button-font-size-md: var(--font-size-md, 1rem);
  }

  .contacts-dialog__uri-submit,
  .contacts-dialog__address-submit,
  .contacts-dialog__submit-contact,
  .contacts-dialog__cancel--footer {
    flex: 1 0 0 !important;
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    inline-size: auto !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    align-self: auto;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .contacts-dialog__group-form .contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__group-submit {
    flex: 0 0 auto;
    width: fit-content;
    min-width: fit-content;
    max-width: fit-content;
    inline-size: fit-content;
    margin: 0 auto;
    align-self: auto;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .contacts-dialog__details {
    width: 100% !important;
    min-width: 0;
    max-height: none;
    padding: var(--spacing-base, 0.5rem) var(--spacing-base, 0.5rem) 0;
    overflow-y: visible;
  }

  .contacts-dialog__address-book-list,
  .contacts-dialog__group-list {
    min-width: 0;
    width: min(100%, var(--contacts-dialog-list-width)) !important;
    max-width: min(100%, var(--contacts-dialog-list-width)) !important;
    margin-inline: auto;
  }

  .contacts-dialog__inline-panel.contacts-dialog__popup,
  .contacts-dialog__group-form,
  .contacts-dialog__uri-entry {
    width: min(100%, var(--contacts-dialog-panel-width)) !important;
    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
    margin-inline: auto !important;
    align-self: center;
  }
}

/* Tablet and stacked panel layout */
@media (max-width: 900px) {
  .contacts-dialog__frame {
    max-height: none;
    overflow: visible;
  }

  .contacts-dialog__body {
    padding-bottom: 0;
    overflow: visible;
  }

  .contacts-dialog__details {
    flex-direction: column !important;
    align-items: stretch !important;
    width: 100% !important;
    max-height: none;
    gap: var(--spacing-base, 0.5rem);
    padding-bottom: 0;
    overflow-y: visible;
    overflow-x: hidden;
  }

  .contacts-dialog__inline-panel-region,
  .contacts-dialog__inline-panel-region--active,
  .contacts-dialog__address-book-list,
  .contacts-dialog__group-list {
    width: min(100%, var(--contacts-dialog-list-width)) !important;
    max-width: min(100%, var(--contacts-dialog-list-width)) !important;
    min-width: 0;
    margin-inline: auto;
    align-self: center;
  }

  .contacts-dialog__address-book-list {
    padding-bottom: var(--spacing-base, 0.5rem);
    border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
  }

  .contacts-dialog__inline-panel.contacts-dialog__popup,
  .contacts-dialog__address-form,
  .contacts-dialog__group-form,
  .contacts-dialog__uri-entry {
    width: min(100%, var(--contacts-dialog-panel-width)) !important;
    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;
    min-width: 0;
    margin-inline: auto;
    align-self: center;
  }

  .contacts-dialog__creation .contacts-dialog__submit-contact {
    width: auto;
    min-width: 0;
    margin-left: 0;
    margin-right: 0;
    align-self: auto;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/specialButtons/addContact/AddMeToYourContacts.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sGAAsG;EACtG,yDAAyD;EACzD,kGAAkG;EAClG,0GAA0G;EAC1G,kHAAkH;EAClH,6HAA6H;EAC7H,4EAA4E;EAC5E,gDAAgD;EAChD,uDAAuD;EACvD,iDAAiD;EACjD,yCAAyC;EACzC,+EAA+E;EAC/E,uDAAuD;EACvD,+PAA+P;EAC/P,8DAA8D;EAC9D,sEAAsE;EACtE,0DAA0D;EAC1D,kEAAkE;EAClE,0EAA0E;EAC1E,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE,sGAAsG;AACxG;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,sGAAsG;EACtG,yDAAyD;EACzD,kGAAkG;EAClG,0GAA0G;EAC1G,kHAAkH;EAClH,6HAA6H;EAC7H,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,0DAA0D;EAC1D,sFAAsF;EACtF,oEAAoE;EACpE,wGAAwG;EACxG,mEAAmE;EACnE,0GAA0G;EAC1G,iGAAiG;EACjG,sGAAsG;EACtG,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,MAAM;AACR;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,4DAA4D;EAC5D,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,oFAAoF;EACpF,kEAAkE;EAClE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,oDAAoD;EACpD,gDAAgD;EAChD,6DAA6D;EAC7D,mEAAmE;EACnE,4BAA4B;EAC5B,wBAAwB;EACxB,iDAAiD;EACjD,yCAAyC;EACzC,2FAA2F;EAC3F,kCAAkC;EAClC,0GAA0G;EAC1G,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,sDAAsD;EACtD,kCAAkC;EAClC,mNAAmN;AACrN;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,yEAAyE;EACzE,4BAA4B;EAC5B,yDAAyD;EACzD,gDAAgD;EAChD,kDAAkD;EAClD,uBAAuB;EACvB,iCAAiC;EACjC,+GAA+G;EAC/G,+EAA+E;EAC/E,+DAA+D;EAC/D,qFAAqF;EACrF,uFAAuF;AACzF;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;;EAEE,+HAA+H;EAC/H,4BAA4B;EAC5B,2HAA2H;EAC3H,yEAAyE;AAC3E;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,gDAAgD;EAChD,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,uDAAuD;EACvD,wEAAwE;EACxE,yEAAyE;EACzE,6EAA6E;EAC7E,iDAAiD;EACjD,yCAAyC;EACzC,4GAA4G;EAC5G,4GAA4G;EAC5G,yFAAyF;EACzF,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,+EAA+E;EAC/E,uDAAuD;EACvD,+PAA+P;AACjQ;;AAEA;;;EAGE,kFAAkF;EAClF,gFAAgF;EAChF,8FAA8F;AAChG;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,6CAA6C;EAC7C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0GAA0G;EAC1G,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,qBAAqB;EACrB,iCAAiC;EACjC,oDAAoD;EACpD,gDAAgD;EAChD,wBAAwB;EACxB,uDAAuD;EACvD,yGAAyG;EACzG,6GAA6G;EAC7G,qCAAqC;EACrC,oCAAoC;EACpC,sGAAsG;EACtG,0GAA0G;EAC1G,kCAAkC;EAClC,0CAA0C;EAC1C,+BAA+B;EAC/B,2CAA2C;EAC3C,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+DAA+D;EAC/D,wDAAwD;EACxD,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;;;EAGE,qBAAqB;EACrB,MAAM;EACN,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,0DAA0D;EAC1D,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,MAAM;EACN,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,0GAA0G;AAC5G;;AAEA;;;EAGE,gBAAgB;EAChB,gEAAgE;EAChE,uFAAuF;EACvF,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uCAAuC;EACvC,0CAA0C;EAC1C,yCAAyC;EACzC,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,8CAA8C;EAC9C,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,gEAAgE;EAChE,wCAAwC;EACxC,oMAAoM;AACtM;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;EAGE,qCAAqC;EACrC,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,mDAAmD;EACnD,4EAA4E;EAC5E,oDAAoD;EACpD,6DAA6D;EAC7D,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oFAAoF;EACpF,kEAAkE;AACpE;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,sEAAsE;EACtE,wCAAwC;EACxC,oEAAoE;EACpE,0EAA0E;EAC1E,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,gEAAgE;EAChE,sCAAsC;EACtC,kCAAkC;EAClC,sEAAsE;EACtE,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sDAAsD;EACtD,kCAAkC;EAClC,kEAAkE;EAClE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,uEAAuE;EACvE,0DAA0D;EAC1D,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,wCAAwC;EACxC,4DAA4D;EAC5D,0DAA0D;EAC1D,kEAAkE;EAClE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA,yBAAyB;;AAEzB;2FAC2F;AAC3F;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,wDAAwD;EACxD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,mEAAmE;EACnE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8DAA8D;EAC9D,kEAAkE;EAClE,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,mEAAmE;AACrE;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,gCAAgC;EAChC,4HAA4H;AAC9H;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,2DAA2D;AAC7D;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,2DAA2D;AAC7D;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;;;;EAIE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kEAAkE;EAClE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,8DAA8D;EAC9D,kEAAkE;EAClE,mBAAmB;AACrB;;AAEA;;;EAGE,+DAA+D;EAC/D,mEAAmE;EACnE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;IACjC,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gDAAgD;EAClD;;EAEA;IACE,wDAAwD;IACxD,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,+DAA+D;IAC/D,mEAAmE;IACnE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,8DAA8D;IAC9D,kEAAkE;IAClE,mBAAmB;EACrB;;EAEA;IACE,+DAA+D;IAC/D,mEAAmE;EACrE;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;;;IAGE,gCAAgC;IAChC,4HAA4H;EAC9H;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,oCAAoC;EACtC;;EAEA;;IAEE,yBAAyB;IACzB,iCAAiC;IACjC,2DAA2D;EAC7D;;EAEA;IACE,uBAAuB;IACvB,iCAAiC;IACjC,2DAA2D;EAC7D;;EAEA;;IAEE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;;;;IAIE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kEAAkE;IAClE,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,8DAA8D;IAC9D,kEAAkE;IAClE,mBAAmB;EACrB;;EAEA;;;IAGE,+DAA+D;IAC/D,mEAAmE;IACnE,8BAA8B;IAC9B,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;IAIE,8DAA8D;IAC9D,kEAAkE;IAClE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,0GAA0G;EAC5G;;EAEA;;;;IAIE,+DAA+D;IAC/D,mEAAmE;IACnE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":["/* Launch button */\n.profile-contacts-button__section {\n  width: 100%;\n  min-width: 0;\n  display: grid;\n}\n\n#add-to-contacts-button-container {\n  position: relative;\n  overflow: visible;\n}\n\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts {\n  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));\n  --profile-contacts-button-background-default: transparent;\n  --profile-contacts-button-text-default: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));\n  --profile-contacts-button-border-hover: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  --profile-contacts-button-background-hover: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));\n  --profile-contacts-button-text-hover: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n  --button-padding-sm: var(--spacing-sm, 0.9375rem) var(--spacing-md, 1.25rem);\n  --button-font-size-sm: var(--font-size-md, 1rem);\n  --button-font-weight: var(--font-weight-normal, normal);\n  --button-border-radius: var(--border-radius-base);\n  --button-transition: all 0.3s ease-in-out;\n  --button-focus-outline: var(--focus-indicator-width) solid var(--color-primary);\n  --button-focus-outline-offset: var(--outline-offset-sm);\n  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-focus-gap, var(--white, #FFF)), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha, rgba(124, 77, 255, 0.2)));\n  --button-border: var(--profile-contacts-button-border-default);\n  --button-background: var(--profile-contacts-button-background-default);\n  --button-text: var(--profile-contacts-button-text-default);\n  --button-hover-border: var(--profile-contacts-button-border-hover);\n  --button-hover-background: var(--profile-contacts-button-background-hover);\n  --button-hover-text: var(--profile-contacts-button-text-hover);\n  color: var(--button-text);\n}\n\nhtml[data-theme=\"dark\"] #add-to-contacts-button-container solid-ui-button.profile__btn-contacts {\n  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));\n}\n\n#add-to-contacts-button-container .profile__btn-contacts-label {\n  color: currentColor;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: 1;\n}\n\n#add-to-contacts-button-container .profile__btn-contacts-icon {\n  width: var(--icon-xxxs, 0.75rem);\n  height: var(--icon-xxxs, 0.75rem);\n  margin-right: var(--spacing-xxs, 0.3125rem);\n  flex-shrink: 0;\n}\n\n#add-to-contacts-button-container .profile__btn-contacts-icon svg {\n  width: var(--icon-xxxs, 0.75rem);\n  height: var(--icon-xxxs, 0.75rem);\n  display: block;\n}\n\n#add-to-contacts-button-container .profile__btn-contacts-icon path {\n  fill: currentColor;\n}\n\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:hover .profile__btn-contacts-label,\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:focus-visible .profile__btn-contacts-label {\n  color: currentColor;\n}\n\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:hover .profile__btn-contacts-icon path,\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts:focus-visible .profile__btn-contacts-icon path {\n  fill: currentColor;\n}\n\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts[disabled],\n#add-to-contacts-button-container solid-ui-button.profile__btn-contacts[aria-disabled=\"true\"] {\n  --profile-contacts-button-border-default: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));\n  --profile-contacts-button-background-default: transparent;\n  --profile-contacts-button-text-default: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));\n  --profile-contacts-button-border-hover: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  --profile-contacts-button-background-hover: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));\n  --profile-contacts-button-text-hover: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n  opacity: 1;\n}\n\n/* Main dialog shell */\n.contacts-dialog__content {\n  --contacts-dialog-action-width: 10.8rem;\n  --contacts-dialog-list-width: 20rem;\n  --contacts-dialog-panel-width: 20.75rem;\n  --contacts-dialog-mobile-popup-max-width: calc(92vw - 5px);\n  --contacts-dialog-panel-border: var(--color-border-lighter, var(--slate-200, #E2E8F0));\n  --contacts-dialog-panel-background: var(--color-background, #F8F9FB);\n  --contacts-dialog-panel-header-background: var(--color-surface-overlay-header, var(--slate-50, #F8FAFC));\n  --contacts-dialog-panel-body-background: var(--color-card-bg, #FFF);\n  --contacts-dialog-panel-padding-inline: calc(var(--spacing-lg, 1.5625rem) + var(--spacing-xxs, 0.3125rem));\n  --contacts-dialog-inner-footer-padding: var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem);\n  --contacts-dialog-inner-footer-padding-mobile: var(--spacing-xs, 0.75rem) var(--spacing-sm, 0.9375rem);\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  max-height: none;\n  min-width: 0;\n}\n\n.contacts-dialog__frame {\n  min-width: 0;\n  background: transparent;\n  border-radius: 0;\n  max-height: none;\n  overflow: visible;\n}\n\n.contacts-dialog__main {\n  width: 100%;\n  min-width: 0;\n  padding: var(--spacing-sm, 0.938rem);\n  box-sizing: border-box;\n}\n\n.contacts-dialog__creation {\n  width: 100%;\n  min-width: 0;\n  border-radius: 0;\n  background: transparent;\n  box-sizing: border-box;\n  padding: 0;\n  gap: 0;\n}\n\n.contacts-dialog__description {\n  padding: var(--spacing-xs, 0.75rem);\n  background: transparent;\n  color: var(--color-text-secondary, var(--gray-600, #4A5565));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-regular, 400);\n}\n\n.contacts-dialog__body {\n  min-width: 0;\n  margin-top: var(--spacing-lg, 1.5625rem);\n  overflow: auto;\n}\n\n.contacts-dialog__footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-sm, 0.938rem);\n  width: auto;\n  min-width: 0;\n  padding: var(--spacing-md, 1.25rem) var(--contacts-dialog-panel-padding-inline);\n  border-top: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);\n  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));\n  box-sizing: border-box;\n}\n\n.contacts-dialog__footer > solid-ui-button {\n  width: var(--contacts-dialog-action-width);\n}\n\n/* Shared button tokens */\nsolid-ui-button.contacts-dialog__action-button {\n  --button-font-size-md: var(--font-size-sm, 0.875rem);\n  --button-font-weight: var(--font-weight-md, 500);\n  --button-background: var(--color-card-bg, var(--white, #FFF));\n  --button-text: var(--color-text-control, var(--slate-700, #314158));\n  --button-border: transparent;\n  --button-border-width: 0;\n  --button-border-radius: var(--border-radius-base);\n  --button-transition: all 0.3s ease-in-out;\n  --button-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));\n  --button-hover-box-shadow: none;\n  --button-active-transform: none;\n  --button-active-box-shadow: none;\n  --button-focus-outline: 3px solid var(--color-primary);\n  --button-focus-outline-offset: 2px;\n  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));\n}\n\nsolid-ui-button.contacts-dialog__action-button--primary {\n  --button-height-md: 0;\n  --button-background: var(--color-primary, #7C4DFF) !important;\n  --button-text: var(--color-text-on-action, var(--white, #FFF)) !important;\n  --button-border-width: 0.8px;\n  --button-border: var(--color-primary, #7C4DFF) !important;\n  --button-font-size-md: var(--font-size-md, 1rem);\n  --button-font-weight: var(--font-weight-bold, 600);\n  --button-line-height: 1;\n  --button-padding-md: 0.85rem 1rem;\n  --button-hover-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 85%, var(--black, #000)) !important;\n  --button-hover-text: var(--color-text-on-action, var(--white, #FFF)) !important;\n  --button-hover-border: var(--color-primary, #7C4DFF) !important;\n  --button-hover-box-shadow: var(--box-shadow-hover, 0 2px 4px rgba(124, 77, 255, 0.2));\n  --button-active-box-shadow: var(--box-shadow-active, 0 1px 2px rgba(124, 77, 255, 0.2));\n}\n\nsolid-ui-button.contacts-dialog__action-button[disabled],\nsolid-ui-button.contacts-dialog__action-button[aria-disabled=\"true\"] {\n  cursor: not-allowed;\n  opacity: 0.55;\n  --button-box-shadow: none !important;\n  --button-hover-box-shadow: none !important;\n  --button-active-box-shadow: none !important;\n  --button-active-transform: none;\n}\n\nsolid-ui-button.contacts-dialog__action-button--primary[disabled],\nsolid-ui-button.contacts-dialog__action-button--primary[aria-disabled=\"true\"] {\n  --button-background: color-mix(in srgb, var(--color-primary, #7C4DFF) 60%, var(--color-card-bg, var(--white, #FFF))) !important;\n  --button-border-width: 0.8px;\n  --button-border: color-mix(in srgb, var(--color-primary, #7C4DFF) 60%, var(--color-card-bg, var(--white, #FFF))) !important;\n  --button-text: var(--color-text-on-action, var(--white, #FFF)) !important;\n}\n\nsolid-ui-button.contacts-dialog__confirm {\n  --button-padding-md: var(--spacing-sm) var(--spacing-md);\n  --button-font-size-md: var(--font-size-md, 1rem);\n  --button-font-weight: var(--font-weight-md, 500);\n  --button-line-height: 1;\n  --button-active-box-shadow: none;\n}\n\nsolid-ui-button.contacts-dialog__cancel {\n  --button-padding-md: var(--spacing-sm) var(--spacing-md);\n  --button-font-size-md: var(--font-size-md, 1rem);\n  --button-font-weight: var(--font-weight-normal, normal);\n  --button-background: var(--dialog-cancel-button-background, transparent);\n  --button-text: var(--dialog-cancel-button-text, var(--gray-800, #1E2939));\n  --button-border: var(--dialog-cancel-button-border, var(--gray-300, #D1D5DC));\n  --button-border-radius: var(--border-radius-base);\n  --button-transition: all 0.3s ease-in-out;\n  --button-hover-background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575)) !important;\n  --button-hover-text: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n  --button-hover-border: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  --button-hover-box-shadow: none;\n  --button-active-transform: none;\n  --button-active-box-shadow: none;\n  --button-focus-outline: var(--focus-indicator-width) solid var(--color-primary);\n  --button-focus-outline-offset: var(--outline-offset-sm);\n  --button-focus-box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-focus-gap, var(--white, #FFF)), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha, rgba(124, 77, 255, 0.2)));\n}\n\nsolid-ui-button.contacts-dialog__cancel:hover::part(button),\nsolid-ui-button.contacts-dialog__cancel:focus-visible::part(button),\nsolid-ui-button.contacts-dialog__cancel:focus-within::part(button) {\n  background: var(--dialog-cancel-button-hover-background, var(--blue-900, #083575));\n  border-color: var(--dialog-cancel-button-hover-border, var(--blue-900, #083575));\n  color: var(--dialog-cancel-button-hover-text, var(--color-text-on-action, var(--white, #FFF)));\n}\n\nsolid-ui-button.contacts-dialog__cancel--footer {\n  width: var(--contacts-dialog-action-width);\n  min-width: var(--contacts-dialog-action-width);\n  max-width: var(--contacts-dialog-action-width);\n  inline-size: var(--contacts-dialog-action-width);\n  align-self: auto;\n}\n\n.contacts-dialog__submit-contact {\n  width: var(--contacts-dialog-action-width) !important;\n  min-width: var(--contacts-dialog-action-width);\n  max-width: var(--contacts-dialog-action-width);\n  inline-size: var(--contacts-dialog-action-width);\n  flex: 0 0 var(--contacts-dialog-action-width);\n  align-self: flex-end;\n  line-height: 1;\n}\n\n.contacts-dialog__address-submit {\n  width: fit-content;\n  min-width: fit-content;\n  max-width: fit-content;\n  inline-size: fit-content;\n  flex: 0 0 auto;\n  align-self: auto;\n  margin: 0 0 0 auto;\n  white-space: nowrap;\n}\n\n.contacts-dialog__group-submit {\n  width: fit-content;\n  min-width: fit-content;\n  max-width: fit-content;\n  inline-size: fit-content;\n  flex: 0 0 auto;\n  align-self: auto;\n  margin: 0 0 0 auto;\n  white-space: nowrap;\n}\n\n.contacts-dialog__uri-submit {\n  width: fit-content;\n  min-width: fit-content;\n  max-width: fit-content;\n  inline-size: fit-content;\n  flex: 0 0 auto;\n  align-self: auto;\n  margin: 0 0 0 auto;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.contacts-dialog__uri-submit::part(button),\n.contacts-dialog__address-submit::part(button) {\n  width: auto;\n  min-width: 0;\n}\n\n/* Selection layout */\n.contacts-dialog__details {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  border-radius: 0;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  gap: var(--spacing-sm, 0.938rem);\n  padding: 0;\n  overflow-x: auto;\n  overflow-y: auto;\n  background: transparent;\n}\n\n.contacts-dialog__address-book-list {\n  flex: 0 0 15rem;\n  width: 100%;\n  max-width: 16rem;\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  box-sizing: border-box;\n}\n\n.contacts-dialog__group-list {\n  width: auto;\n  max-width: 14rem;\n  min-width: 12.5rem;\n  box-sizing: border-box;\n  gap: 1px;\n}\n\n.contacts-dialog__column-title {\n  margin: 0 0 0.35rem;\n  padding-bottom: 0.35rem;\n  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-lg, 1.125rem);\n}\n\n#addressbook-list > solid-ui-button#contacts-create-addressbook-button,\n#addressbook-list > solid-ui-button#contacts-addressbook-uri-entry-button,\n#group-list > solid-ui-button#contacts-create-group-button {\n  width: 100% !important;\n  min-width: 100% !important;\n  max-width: 100% !important;\n  inline-size: 100% !important;\n}\n\nsolid-ui-button.contacts-dialog__list-button {\n  flex-shrink: 0;\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  --button-height-sm: 0;\n  --button-padding-sm: 0.85rem 1rem;\n  --button-font-size-sm: var(--font-size-sm, 0.875rem);\n  --button-font-weight: var(--font-weight-md, 500);\n  --button-border-width: 0;\n  --button-border-radius: var(--border-radius-md, 0.5rem);\n  --button-selected-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff)) !important;\n  --button-selected-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));\n  --button-selected-border: transparent;\n  --button-box-shadow: none !important;\n  --button-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff)) !important;\n  --button-hover-text: var(--color-text-accent-subtle, var(--color-text-control, var(--slate-700, #314158)));\n  --button-hover-border: transparent;\n  --button-hover-box-shadow: none !important;\n  --button-active-transform: none;\n  --button-active-box-shadow: none !important;\n  --button-focus-outline: none;\n  --button-focus-box-shadow: none !important;\n}\n\n/* Inline panel shells */\n.contacts-dialog__inline-panel-region {\n  display: none;\n  min-width: 0;\n  order: 3;\n}\n\n.contacts-dialog__inline-panel-region--active {\n  display: block;\n  min-width: 0;\n  width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  max-width: var(--contacts-dialog-panel-width) !important;\n  align-self: flex-start;\n  order: 3;\n}\n\n.contacts-dialog__inline-panel.contacts-dialog__popup {\n  position: static;\n  inset: auto;\n  transform: none;\n  min-width: 0;\n  width: 100% !important;\n  max-width: 100% !important;\n  max-height: none;\n  margin: 0;\n  margin-right: 0;\n  overflow: visible;\n  box-shadow: none;\n  border-left: 1px solid var(--contacts-dialog-panel-border);\n}\n\n.contacts-dialog__address-form,\n.contacts-dialog__group-form,\n.contacts-dialog__uri-entry {\n  padding: 0 !important;\n  gap: 0;\n  box-sizing: border-box;\n  border-radius: var(--border-radius-base);\n}\n\n.contacts-dialog__address-form {\n  width: 100% !important;\n  max-width: 100% !important;\n  align-items: stretch;\n  border: 1px solid var(--contacts-dialog-panel-border);\n  background: var(--contacts-dialog-panel-background);\n}\n\n.contacts-dialog__group-form {\n  border: none;\n  border-left: 1px solid var(--contacts-dialog-panel-border);\n  border-radius: 0;\n  background: var(--contacts-dialog-panel-background);\n}\n\n.contacts-dialog__uri-entry {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0;\n  align-self: flex-start;\n  border: 1px solid var(--contacts-dialog-panel-border);\n  background: var(--contacts-dialog-panel-background);\n}\n\n.contacts-dialog__uri-entry-form {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  align-items: stretch;\n  box-sizing: border-box;\n  gap: 0;\n  background: var(--color-card-bg, #FFF);\n}\n\n/* Popup chrome */\n.contacts-dialog__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-sm, 0.938rem);\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.contacts-dialog__title {\n  margin: 0;\n  min-width: 0;\n  flex: 1 1 auto;\n  line-height: 1.3;\n  font-size: var(--font-size-md);\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n}\n\n.contacts-dialog__popup .contacts-dialog__header {\n  border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n}\n\n.contacts-dialog__address-form .contacts-dialog__header,\n.contacts-dialog__group-form .contacts-dialog__header,\n.contacts-dialog__uri-entry .contacts-dialog__header {\n  margin-bottom: 0;\n  padding: var(--spacing-md, 1.25rem) var(--spacing-lg, 1.5625rem);\n  border-bottom: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);\n  background: var(--contacts-dialog-panel-header-background);\n}\n\nsolid-ui-button.contacts-dialog__close {\n  flex: 0 0 auto;\n  align-self: flex-start;\n  min-inline-size: var(--icon-base, 2rem);\n  --button-height-sm: var(--icon-base, 2rem);\n  --button-width-sm: var(--icon-base, 2rem);\n  --button-padding-sm: 0;\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-border-radius: 999px;\n  --button-text: var(--color-text);\n  --button-box-shadow: none;\n  --button-hover-background: rgba(0, 0, 0, 0.04);\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary);\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n  --button-active-transform: none;\n  --button-icon-size-sm: var(--icon-xxs, 1rem);\n}\n\nsolid-ui-button.contacts-dialog__close:focus-visible::part(button) {\n  outline: var(--focus-indicator-width) solid var(--color-primary);\n  outline-offset: var(--outline-offset-sm);\n  box-shadow: var(--box-shadow-focus-accessible, 0 0 0 var(--focus-ring-width) var(--color-background), 0 0 0 calc(var(--focus-ring-width) + var(--focus-indicator-width)) var(--color-primary-alpha));\n}\n\n.contacts-dialog__popup-body {\n  min-width: 0;\n  gap: var(--spacing-base, 0.5rem);\n}\n\n.contacts-dialog__address-form .contacts-dialog__popup-body,\n.contacts-dialog__group-form .contacts-dialog__popup-body,\n.contacts-dialog__uri-entry .contacts-dialog__popup-body {\n  padding: var(--spacing-lg, 1.5625rem);\n  box-sizing: border-box;\n  background: var(--contacts-dialog-panel-body-background);\n}\n\n.contacts-dialog__popup .input {\n  width: 100%;\n  max-width: 100%;\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));\n  background: var(--color-card-bg, var(--white, #FFF));\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  padding: var(--spacing-2xs, 0.625rem);\n  box-sizing: border-box;\n  margin-bottom: var(--spacing-base, 0.5rem);\n}\n\n.contacts-dialog__address-form .input,\n.contacts-dialog__group-form .input,\n.contacts-dialog__uri-entry .input {\n  margin-bottom: 0;\n}\n\n.contacts-dialog__uri-input {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  display: block;\n  flex: 1 1 auto;\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n.contacts-dialog__popup-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  align-self: stretch;\n  box-sizing: border-box;\n  gap: var(--spacing-md);\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: var(--border-width-sm, 0.1rem) solid var(--contacts-dialog-panel-border);\n  background: var(--color-surface-tertiary, var(--gray-50, #F9FAFB));\n}\n\n.contacts-dialog__address-form .contacts-dialog__popup-footer,\n.contacts-dialog__group-form .contacts-dialog__popup-footer,\n.contacts-dialog__uri-entry .contacts-dialog__popup-footer {\n  margin-top: 0;\n  gap: var(--spacing-sm, 0.9375rem);\n  padding: var(--contacts-dialog-inner-footer-padding);\n}\n\n.contacts-dialog__address-form .contacts-dialog__popup-footer,\n.contacts-dialog__uri-entry-form .contacts-dialog__popup-footer {\n  justify-content: flex-end;\n}\n\n.contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__confirm,\n.contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__cancel {\n  width: var(--contacts-dialog-action-width);\n  min-width: var(--contacts-dialog-action-width);\n  max-width: var(--contacts-dialog-action-width);\n  inline-size: var(--contacts-dialog-action-width);\n}\n\n/* Validation and feedback */\n.contacts-dialog__validation {\n  display: none;\n  width: calc(100% - 0.5rem);\n  max-width: calc(100% - 0.5rem);\n  margin: 0 auto;\n  padding-right: 0.25rem;\n  padding-left: 0.25rem;\n  align-self: stretch;\n  box-sizing: border-box;\n  color: var(--red-600, #B00020);\n  font-size: var(--font-size-sm, 0.875rem);\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  text-align: left;\n}\n\n.contacts-dialog__validation--visible {\n  display: block;\n}\n\n.contacts-dialog__error,\n.contacts-dialog__error[role='alert'] {\n  position: relative;\n  z-index: 3;\n  display: none;\n  width: 100%;\n  align-self: stretch;\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));\n  border-radius: var(--border-radius-base);\n  background: var(--dialog-error-background, var(--pink-500, #ffdde6));\n  background-color: var(--dialog-error-background, var(--pink-500, #ffdde6));\n  color: var(--dialog-error-text, var(--red-600, #B00020));\n  text-align: center;\n}\n\n.contacts-dialog__error--visible {\n  display: flex !important;\n  flex-direction: row;\n  justify-content: center;\n}\n\nsolid-ui-button.contacts-dialog__error-close {\n  position: absolute;\n  top: var(--spacing-xxxs, 0.2rem);\n  right: var(--spacing-xxxs, 0.2rem);\n  z-index: 4;\n  --button-height-sm: 0;\n  --button-padding-sm: 0;\n  --button-font-size-sm: var(--font-size-sm);\n  --button-background: transparent;\n  --button-border: transparent;\n  --button-border-width: 0;\n  --button-border-radius: 0;\n  --button-text: var(--dialog-error-text, var(--red-600, #B00020));\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: var(--dialog-error-text, var(--red-600, #B00020));\n  --button-line-height: 1;\n  --button-active-transform: none;\n  --button-box-shadow: none;\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n}\n\n/* Overlays and confirmation popups */\n.contacts-dialog__popup-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 8;\n  background: color-mix(in srgb, var(--black, #000) 50%, transparent);\n}\n\n.contacts-dialog__popup {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n  width: min(calc(24rem - 5px), calc(100% - 1rem - 5px));\n  max-width: calc(100% - 1rem - 5px);\n  max-height: min(calc(100% - 1rem - 5px), calc(100vh - 6rem - 5px));\n  padding: 1rem;\n  box-sizing: border-box;\n  overflow: auto;\n  overflow-x: hidden;\n  transform: translate(-50%, -50%);\n  border-radius: var(--border-radius-base);\n  background: var(--color-surface-overlay, var(--white, #FFF)) !important;\n  color: var(--color-text-overlay, var(--gray-800, #1E2939));\n  box-shadow: var(--box-shadow-overlay, 0 4px 24px rgba(0, 0, 0, 0.2));\n}\n\n.contacts-dialog__shared-confirm-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.contacts-dialog__shared-confirm-message {\n  margin: 0;\n  color: var(--color-text-overlay, var(--gray-800, #1E2939));\n}\n\n.contacts-dialog__shared-confirm-name {\n  font-weight: var(--font-weight-bold, 600);\n}\n\n.contacts-dialog__contact-exists {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 10;\n  width: min(90vw, 20rem);\n  padding: 1rem;\n  transform: translate(-50%, -50%);\n  border-radius: var(--border-radius-base);\n  background: var(--color-surface-overlay, var(--white, #FFF));\n  color: var(--color-text-overlay, var(--gray-800, #1E2939));\n  box-shadow: var(--box-shadow-modal, 0 2px 10px rgba(0, 0, 0, 0.3));\n  align-items: center;\n  gap: var(--spacing-md, 1rem);\n  text-wrap: pretty;\n}\n\n.contacts-dialog__contact-exists .contacts-dialog__popup-footer {\n  width: 100%;\n  justify-content: center;\n  gap: var(--spacing-2xs, 0.625rem);\n  margin-top: var(--spacing-base, 0.5rem);\n  padding-top: 0;\n  border-top: none;\n  background: transparent;\n}\n\n.contacts-dialog__contact-exists .contacts-dialog__confirm,\n.contacts-dialog__contact-exists .contacts-dialog__cancel {\n  width: auto;\n  min-width: 6rem;\n  flex: 0 0 auto;\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* Responsive overrides */\n\n/* Explicit mobile layout mode uses the same values as the small-screen rules,\n   but plain CSS still needs a separate block because `data-layout` is not a media query. */\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__frame {\n  max-height: none;\n  overflow: visible;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__body {\n  padding-bottom: 0;\n  overflow: visible;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__footer {\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--spacing-sm, 0.9375rem);\n  width: 100%;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__footer > solid-ui-button {\n  flex: 1 0 0;\n  width: auto;\n  min-width: 0;\n  max-width: none;\n  inline-size: auto;\n  --button-font-size-md: var(--font-size-md, 1rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__popup {\n  max-width: var(--contacts-dialog-mobile-popup-max-width);\n  max-height: 78vh;\n  padding: 0.85rem;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form {\n  width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  margin-inline: auto;\n  padding: 0 !important;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel-region {\n  min-width: 0;\n  width: min(100%, var(--contacts-dialog-list-width)) !important;\n  max-width: min(100%, var(--contacts-dialog-list-width)) !important;\n  margin-inline: auto;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel-region--active {\n  width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__header,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__header,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__header {\n  padding: var(--spacing-sm, 0.9375rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-body,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-body,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-body {\n  gap: var(--spacing-base, 0.5rem);\n  padding: var(--spacing-sm, 0.9375rem) var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem) var(--spacing-sm, 0.9375rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .input {\n  min-height: 2.5rem;\n  height: 2.5rem;\n  margin-bottom: 0.375rem;\n  padding: var(--spacing-base, 0.5rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-footer,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-footer {\n  justify-content: flex-end;\n  gap: var(--spacing-sm, 0.9375rem);\n  padding: var(--contacts-dialog-inner-footer-padding-mobile);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-footer {\n  justify-content: center;\n  gap: var(--spacing-sm, 0.9375rem);\n  padding: var(--contacts-dialog-inner-footer-padding-mobile);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry .contacts-dialog__popup-footer > solid-ui-button,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-form .contacts-dialog__popup-footer > solid-ui-button {\n  flex: 1 0 0;\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: none !important;\n  inline-size: auto !important;\n  --button-font-size-md: var(--font-size-md, 1rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-submit,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-submit,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__submit-contact,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__cancel--footer {\n  flex: 1 0 0 !important;\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: none !important;\n  inline-size: auto !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  align-self: auto;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form .contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__group-submit {\n  flex: 0 0 auto;\n  width: fit-content;\n  min-width: fit-content;\n  max-width: fit-content;\n  inline-size: fit-content;\n  margin: 0 auto;\n  align-self: auto;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__details {\n  width: 100% !important;\n  min-width: 0;\n  max-height: none;\n  padding: var(--spacing-base, 0.5rem) var(--spacing-base, 0.5rem) 0;\n  overflow-y: visible;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__address-book-list,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-list {\n  min-width: 0;\n  width: min(100%, var(--contacts-dialog-list-width)) !important;\n  max-width: min(100%, var(--contacts-dialog-list-width)) !important;\n  margin-inline: auto;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__inline-panel.contacts-dialog__popup,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__group-form,\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .contacts-dialog__uri-entry {\n  width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  margin-inline: auto !important;\n  align-self: center;\n}\n\n@media (max-width: 576px) {\n  .contacts-dialog__frame {\n    max-height: none;\n    overflow: visible;\n  }\n\n  .contacts-dialog__body {\n    padding-bottom: 0;\n    overflow: visible;\n  }\n\n  .contacts-dialog__footer {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: var(--spacing-sm, 0.9375rem);\n    width: 100%;\n  }\n\n  .contacts-dialog__footer > solid-ui-button {\n    flex: 1 0 0;\n    width: auto;\n    min-width: 0;\n    max-width: none;\n    inline-size: auto;\n    --button-font-size-md: var(--font-size-md, 1rem);\n  }\n\n  .contacts-dialog__popup {\n    max-width: var(--contacts-dialog-mobile-popup-max-width);\n    max-height: 78vh;\n    padding: 0.85rem;\n  }\n\n  .contacts-dialog__address-form {\n    width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    margin-inline: auto;\n    padding: 0 !important;\n  }\n\n  .contacts-dialog__inline-panel-region {\n    min-width: 0;\n    width: min(100%, var(--contacts-dialog-list-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-list-width)) !important;\n    margin-inline: auto;\n  }\n\n  .contacts-dialog__inline-panel-region--active {\n    width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n  }\n\n  .contacts-dialog__address-form .contacts-dialog__header,\n  .contacts-dialog__group-form .contacts-dialog__header,\n  .contacts-dialog__uri-entry .contacts-dialog__header {\n    padding: var(--spacing-sm, 0.9375rem);\n  }\n\n  .contacts-dialog__address-form .contacts-dialog__popup-body,\n  .contacts-dialog__group-form .contacts-dialog__popup-body,\n  .contacts-dialog__uri-entry .contacts-dialog__popup-body {\n    gap: var(--spacing-base, 0.5rem);\n    padding: var(--spacing-sm, 0.9375rem) var(--spacing-sm, 0.9375rem) var(--spacing-lg, 1.5625rem) var(--spacing-sm, 0.9375rem);\n  }\n\n  .contacts-dialog__address-form .input {\n    min-height: 2.5rem;\n    height: 2.5rem;\n    margin-bottom: 0.375rem;\n    padding: var(--spacing-base, 0.5rem);\n  }\n\n  .contacts-dialog__uri-entry .contacts-dialog__popup-footer,\n  .contacts-dialog__address-form .contacts-dialog__popup-footer {\n    justify-content: flex-end;\n    gap: var(--spacing-sm, 0.9375rem);\n    padding: var(--contacts-dialog-inner-footer-padding-mobile);\n  }\n\n  .contacts-dialog__group-form .contacts-dialog__popup-footer {\n    justify-content: center;\n    gap: var(--spacing-sm, 0.9375rem);\n    padding: var(--contacts-dialog-inner-footer-padding-mobile);\n  }\n\n  .contacts-dialog__uri-entry .contacts-dialog__popup-footer > solid-ui-button,\n  .contacts-dialog__address-form .contacts-dialog__popup-footer > solid-ui-button {\n    flex: 1 0 0;\n    width: auto !important;\n    min-width: 0 !important;\n    max-width: none !important;\n    inline-size: auto !important;\n    --button-font-size-md: var(--font-size-md, 1rem);\n  }\n\n  .contacts-dialog__uri-submit,\n  .contacts-dialog__address-submit,\n  .contacts-dialog__submit-contact,\n  .contacts-dialog__cancel--footer {\n    flex: 1 0 0 !important;\n    width: auto !important;\n    min-width: 0 !important;\n    max-width: none !important;\n    inline-size: auto !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    align-self: auto;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n\n  .contacts-dialog__group-form .contacts-dialog__popup-footer > solid-ui-button.contacts-dialog__group-submit {\n    flex: 0 0 auto;\n    width: fit-content;\n    min-width: fit-content;\n    max-width: fit-content;\n    inline-size: fit-content;\n    margin: 0 auto;\n    align-self: auto;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .contacts-dialog__details {\n    width: 100% !important;\n    min-width: 0;\n    max-height: none;\n    padding: var(--spacing-base, 0.5rem) var(--spacing-base, 0.5rem) 0;\n    overflow-y: visible;\n  }\n\n  .contacts-dialog__address-book-list,\n  .contacts-dialog__group-list {\n    min-width: 0;\n    width: min(100%, var(--contacts-dialog-list-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-list-width)) !important;\n    margin-inline: auto;\n  }\n\n  .contacts-dialog__inline-panel.contacts-dialog__popup,\n  .contacts-dialog__group-form,\n  .contacts-dialog__uri-entry {\n    width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    margin-inline: auto !important;\n    align-self: center;\n  }\n}\n\n/* Tablet and stacked panel layout */\n@media (max-width: 900px) {\n  .contacts-dialog__frame {\n    max-height: none;\n    overflow: visible;\n  }\n\n  .contacts-dialog__body {\n    padding-bottom: 0;\n    overflow: visible;\n  }\n\n  .contacts-dialog__details {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    width: 100% !important;\n    max-height: none;\n    gap: var(--spacing-base, 0.5rem);\n    padding-bottom: 0;\n    overflow-y: visible;\n    overflow-x: hidden;\n  }\n\n  .contacts-dialog__inline-panel-region,\n  .contacts-dialog__inline-panel-region--active,\n  .contacts-dialog__address-book-list,\n  .contacts-dialog__group-list {\n    width: min(100%, var(--contacts-dialog-list-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-list-width)) !important;\n    min-width: 0;\n    margin-inline: auto;\n    align-self: center;\n  }\n\n  .contacts-dialog__address-book-list {\n    padding-bottom: var(--spacing-base, 0.5rem);\n    border-bottom: var(--border-width-sm, 0.1rem) solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n  }\n\n  .contacts-dialog__inline-panel.contacts-dialog__popup,\n  .contacts-dialog__address-form,\n  .contacts-dialog__group-form,\n  .contacts-dialog__uri-entry {\n    width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    max-width: min(100%, var(--contacts-dialog-panel-width)) !important;\n    min-width: 0;\n    margin-inline: auto;\n    align-self: center;\n  }\n\n  .contacts-dialog__creation .contacts-dialog__submit-contact {\n    width: auto;\n    min-width: 0;\n    margin-left: 0;\n    margin-right: 0;\n    align-self: auto;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
